import type { FC } from 'react';
import React, { isValidElement, cloneElement, Children } from 'react';

import type { ISwitchProps } from '../../models';

export const Switch: FC<ISwitchProps> = ({
    children,
    className,
    keepMount,
    visible,
}): JSX.Element => (
    <>
        {Children.map(children, child => {
            if (isValidElement(child)) {
                return cloneElement(child, {
                    keepMount,
                    className,
                    ...child.props,
                    visibleId: visible,
                });
            }
        })}
    </>
);
